<template>
  <v-app
    :light="$theme.light"
    :dark="$theme.dark"
    id="app"
    :style="`background: url(${background})`"
    class="bg-theme"
  >
    <!-- <v-btn @click="getBluetooth">Bt</v-btn>
    <v-btn @click="requestPort">Port</v-btn> -->
    <!-- <video class="video"></video> -->
    <router-view />
    <ModalConfirmAction />
    <ModalLoading />
    <ModalGlobalMessage />
    <AdminOnboardingModal />
    <v-snackbar v-model="saleUpdateSnack" right bottom timeout="9000" color="#182229">
      <div class="d-flex align-center">
        <v-icon color="#25D366" class="mr-2">mdi-satellite-uplink</v-icon>
        <span>{{ saleUpdateMessage }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text color="#25D366" v-bind="attrs" @click="openSaleUpdate">Abrir venda</v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="internalChatSnack" right bottom timeout="9000" color="transparent" elevation="0" content-class="app-internal-snackbar">
      <div class="app-internal-snackbar-card" :class="{ 'app-internal-snackbar-card-dark': isDarkTheme }" @click="openInternalChatNotification">
        <div class="app-internal-snackbar-icon"><v-icon class="app-internal-snackbar-glyph">mdi-message-text</v-icon></div>
        <v-avatar size="44" class="app-internal-snackbar-avatar"><v-icon class="app-internal-snackbar-glyph">mdi-account</v-icon></v-avatar>
        <div class="app-internal-snackbar-copy">
          <strong>{{ internalChatTitle }}</strong>
          <small>{{ internalChatPreview }}</small>
        </div>
        <v-icon class="app-internal-snackbar-chevron">mdi-chevron-right</v-icon>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn class="app-internal-snackbar-action" :class="{ 'app-internal-snackbar-action-dark': isDarkTheme }" icon small v-bind="attrs" @click.stop="internalChatSnack = false">
          <v-icon small :color="isDarkTheme ? '#e9edef' : '#173b33'">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <transition name="whatsapp-offer">
      <div v-if="whatsappOffer" class="whatsapp-offer-shell">
        <v-card class="whatsapp-offer-card pa-5" dark>
          <div class="whatsapp-offer-pulse" />
          <div class="d-flex align-center">
            <v-avatar color="#25D366" size="54"><v-icon dark large>mdi-whatsapp</v-icon></v-avatar>
            <div class="ml-4">
              <div class="overline green--text text--accent-3">Nova chamada de atendimento</div>
              <h2>{{ (offerConversation.client && offerConversation.client.nome) || offerConversation.contact_name || "Novo cliente" }}</h2>
              <div class="grey--text text--lighten-1">{{ offerConversation.contact_phone || offerConversation.contact_id }}</div>
            </div>
          </div>
          <div class="whatsapp-offer-message mt-4">{{ offerMessageText }}</div>
          <div class="d-flex mt-5" style="gap: 10px;">
            <v-btn outlined dark @click="whatsappOffer = null">Agora não</v-btn>
            <v-btn color="#25D366" :loading="acceptingWhatsapp" @click="acceptWhatsappOffer">
              <v-icon left>mdi-headset</v-icon>Aceitar atendimento
            </v-btn>
          </div>
        </v-card>
      </div>
    </transition>
  </v-app>
</template>

<script>
import ModalConfirmAction from "@/apps/shared/components/ModalConfirmAction";
import ModalLoading from "@/apps/shared/components/ModalLoading";
import ModalGlobalMessage from "@/apps/shared/components/ModalGlobalMessage";
import AdminOnboardingModal from "@/apps/AdminOnboarding/views/OnboardingModal.vue";
import { EventBus } from "./main.js";
import { startWhatsappGatewayRuntime, stopWhatsappGatewayRuntime } from "@/apps/WhatsappAtendimento/runtime";
import { acceptWhatsappConversation, startWhatsappBackendSocket, stopWhatsappBackendSocket } from "@/apps/WhatsappAtendimento/backendSocketClient";

export default {
  components: {
    ModalConfirmAction,
    ModalLoading,
    ModalGlobalMessage,
    AdminOnboardingModal
  },
  data() {
    return {
      background:
        "https://trello-backgrounds.s3.amazonaws.com/SharedBackground/2400x1600/561bf177fe09f4ba6221e5b4a76a152f/photo-1611760045609-d98d8587a60f.jpg",
      whatsappOffer: null,
      acceptingWhatsapp: false,
      saleUpdateSnack: false,
      saleUpdate: null,
      internalChatSnack: false,
      internalChatNotification: null,
      // "https://www.10wallpaper.com/wallpaper/1366x768/1604/Jungle_river_trees_moss_lianas-Nature_High_Quality_Wallpaper_1366x768.jpg"
      // background: 'https://images7.alphacoders.com/130/1308057.jpeg',
      // background: 'https://c.wallhere.com/photos/82/b5/1280x744_px_Abstract_Field_Abstract_Mountain_Nature_Wallpaper_Image_cool_hs_photos_field_photos_hd_images_for_desktop_hd_wallpapers_landscapes-801866.jpg!d',
    };
  },
  computed: {
    offerConversation() {
      return this.whatsappOffer?.conversation || {};
    },
    offerMessageText() {
      return this.whatsappOffer?.message?.text || "Nova mensagem recebida.";
    },
    saleUpdateMessage() {
      return this.saleUpdate?.event?.description || "Uma venda vinculada a você foi atualizada.";
    },
    internalChatTitle() {
      return this.internalChatNotification?.sender?.nome || "Nova mensagem interna";
    },
    internalChatPreview() {
      return this.internalChatNotification?.message?.text || "Clique para abrir a conversa interna.";
    },
    isDarkTheme() {
      return Boolean(this.$theme?.dark || localStorage.dark === "true");
    },
  },
  methods: {
    openSaleUpdate() {
      const route = this.saleUpdate?.route || (this.saleUpdate?.sale_id ? `/gestordepedidos/venda/${this.saleUpdate.sale_id}` : "");
      this.saleUpdateSnack = false;
      if (route) this.$router.push(route).catch(() => {});
    },
    openInternalChatNotification() {
      this.internalChatSnack = false;
      const sender = this.internalChatNotification?.sender;
      const query = sender?._id ? { internalUserId: sender._id } : {};
      this.$router.push({ path: "/whatsapp-atendimento", query }).catch(() => {});
    },
    currentUserId() {
      const token = localStorage.token ? JSON.parse(localStorage.token) : "";
      if (!token) return "";
      try {
        const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        const payload = JSON.parse(atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, "=")));
        return String(payload.id || "");
      } catch {
        return "";
      }
    },
    isInternalMessageMine(message) {
      return String(message?.sender?._id || "") === this.currentUserId();
    },
    entityId(value) {
      if (!value) return "";
      if (typeof value === "string") return value;
      return value._id || value.id || value.user_id || "";
    },
    collectEntityIds(target, keys) {
      return keys.flatMap(key => {
        const value = target?.[key];
        if (!value) return [];
        return Array.isArray(value) ? value.map(this.entityId) : [this.entityId(value)];
      }).map(String).filter(Boolean);
    },
    internalChatParticipantIds(payload = {}) {
      const conversation = payload.conversation || {};
      const message = payload.message || {};
      return [
        ...this.collectEntityIds(payload, ["participants", "participant_ids", "users"]),
        ...this.collectEntityIds(conversation, ["participants", "participant_ids", "users"]),
        ...this.collectEntityIds(message, ["sender", "recipient", "receiver", "to", "from"]),
        ...this.collectEntityIds(message, ["sender_id", "recipient_id", "receiver_id", "to_user_id", "from_user_id"])
      ].map(String).filter(Boolean);
    },
    isInternalChatForCurrentUser(payload) {
      const participants = [...new Set(this.internalChatParticipantIds(payload))];
      return Boolean(participants.length && participants.includes(this.currentUserId()));
    },
    notifyInternalChat(payload) {
      const message = payload?.message;
      if (!message?._id || this.isInternalMessageMine(message) || !this.isInternalChatForCurrentUser(payload)) return;
      this.internalChatNotification = { ...payload, sender: message.sender || {} };
      this.internalChatSnack = true;
      this.playNotificationSound();
    },
    playNotificationSound() {
      const audio = new Audio("call_in.mp3");
      audio.volume = 0.58;
      void audio.play().catch(() => this.playBeepFallback());
    },
    playBeepFallback() {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        const context = new AudioContext();
        const gain = context.createGain();
        gain.gain.setValueAtTime(0.0001, context.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.08, context.currentTime + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.24);
        gain.connect(context.destination);
        [660, 880].forEach((frequency, index) => {
          const oscillator = context.createOscillator();
          oscillator.type = "sine";
          oscillator.frequency.setValueAtTime(frequency, context.currentTime + index * 0.09);
          oscillator.connect(gain);
          oscillator.start(context.currentTime + index * 0.09);
          oscillator.stop(context.currentTime + index * 0.09 + 0.12);
        });
        setTimeout(() => context.close(), 450);
      } catch {
      }
    },
    async acceptWhatsappOffer() {
      this.acceptingWhatsapp = true;
      try {
        const conversation = await acceptWhatsappConversation(this.offerConversation._id);
        this.whatsappOffer = null;
        this.$router.push({ path: "/whatsapp-atendimento", query: { conversationId: conversation._id } });
      } finally {
        this.acceptingWhatsapp = false;
      }
    },

    async getBluetooth() {
      const bluetoothDevices2 = await navigator.bluetooth.requestDevice();
    },
    async requestPort() {
      const port = await navigator.serial.requestPort();
      port.open({ baudRate: 9600 });
    }
  },
  watch: {
    $route(to) {
      this.$store.dispatch("AdminOnboarding/check_and_open", { route: to });
    }
  },
  async created() {
    if ("serial" in navigator) {
      // The Web Serial API is supported.
      // console.log("serial disponível", navigator);
      // const ports = await navigator.serial.();
      // const ports = await navigator.serial.getPorts();
      // const devices = await navigator.mediaDevices.enumerateDevices();
      // const bluetoothDevices = await navigator.bluetooth.getAvailability();
      // let mediadevices = navigator.getUserMedia();
      // console.log("lista de devices", mediadevices);
      // console.log("lista de devices", devices);
      // console.log("lista de ports", ports);
      // console.log("lista de bt", bluetoothDevices);
      // navigator.getMedia(
      //   // permissoes
      //   {
      //     video: true,
      //     audio: true
      //   },
      //   // callbackSucesso
      //   function(localMediaStream) {
      //     var video = document.querySelector(".video");
      //     video.src = window.URL.createObjectURL(localMediaStream);
      //     video.onloadedmetadata = function(e) {
      //       console.log("e", e);
      //       // Faz algo com o vídeo aqui.
      //     };
      //   },
      //   // callbackErro
      //   function(err) {
      //     console.log("O seguinte erro ocorreu: " + err);
      //   }
      // );
    }
  },
  async mounted() {
    const component = this;
    this.handler = function(e) {
      component.$emit("keydown", e);
      // console.log("e", e);
      if (e.key === "Escape") {
        EventBus.$emit("escape", true);
      }
      if (e.key === "ArrowUp") {
        EventBus.$emit("ArrowUp", true);
      }
      if (e.key === "ArrowDown") {
        EventBus.$emit("ArrowDown", true);
      }
      if (e.key === "ArrowRight") {
        EventBus.$emit("ArrowRight", true);
      }
      if (e.key === "ArrowLeft") {
        EventBus.$emit("ArrowLeft", true);
      }
      if (e.key === "Enter") {
        EventBus.$emit("Enter", true);
      }
      //detect ctrl key
      if (e.key === "Control") {
        EventBus.$emit("CtrlDown", true);
      }
    };
    this.handlerUp = function(e) {
      component.$emit("keyup", e);
      //detect ctrl key
      // if (e.key === "Control") {
      //   EventBus.$emit("CtrlUp");
      // }
    };
    window.addEventListener("keydown", this.handler);
    window.addEventListener("keyup", this.handlerUp);
    this.whatsappOfferHandler = event => {
      this.whatsappOffer = event.detail || null;
      const audio = new Audio("call_in.mp3");
      void audio.play().catch(() => {});
    };
    this.whatsappAssignedHandler = event => {
      if (event.detail?.conversation?._id === this.offerConversation?._id) this.whatsappOffer = null;
    };
    this.saleUpdatedHandler = event => {
      this.saleUpdate = event.detail || null;
      this.saleUpdateSnack = Boolean(this.saleUpdate?.sale_id || this.saleUpdate?.route);
    };
    this.internalChatHandler = event => this.notifyInternalChat(event.detail || {});
    window.addEventListener("stonepro:whatsapp-offer", this.whatsappOfferHandler);
    window.addEventListener("stonepro:whatsapp-assigned", this.whatsappAssignedHandler);
    window.addEventListener("stonepro:sale-updated", this.saleUpdatedHandler);
    window.addEventListener("stonepro:internal-chat-message", this.internalChatHandler);
    startWhatsappGatewayRuntime();
    startWhatsappBackendSocket();
    this.$nextTick(() => {
      this.$store.dispatch("AdminOnboarding/check_and_open", { route: this.$route });
      this.$store.dispatch("AdminOnboarding/listen_saves");
    });
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handler);
    window.removeEventListener("keyup", this.handlerUp);
    window.removeEventListener("stonepro:whatsapp-offer", this.whatsappOfferHandler);
    window.removeEventListener("stonepro:whatsapp-assigned", this.whatsappAssignedHandler);
    window.removeEventListener("stonepro:sale-updated", this.saleUpdatedHandler);
    window.removeEventListener("stonepro:internal-chat-message", this.internalChatHandler);
    stopWhatsappGatewayRuntime();
    stopWhatsappBackendSocket();
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Poppins:wght@500;600;700;800&display=swap");
:root {
  --background-base: #f3edda;
}
.whatsapp-offer-shell {
  position: fixed;
  right: 28px;
  bottom: 28px;
  z-index: 9999;
  width: min(520px, calc(100vw - 40px));
}
.whatsapp-offer-card {
  overflow: hidden;
  border-radius: 18px !important;
  background: linear-gradient(135deg, #15231d, #101714) !important;
  box-shadow: 0 18px 60px rgba(0, 0, 0, .42) !important;
  border: 1px solid rgba(37, 211, 102, .35);
}
.whatsapp-offer-pulse {
  position: absolute;
  inset: -40%;
  background: radial-gradient(circle, rgba(37, 211, 102, .18), transparent 58%);
  animation: whatsapp-pulse 2s ease-in-out infinite;
}
.whatsapp-offer-message { position: relative; padding: 13px; border-radius: 12px; background: rgba(255,255,255,.08); }
.whatsapp-offer-enter-active, .whatsapp-offer-leave-active { transition: .35s ease; }
.whatsapp-offer-enter, .whatsapp-offer-leave-to { transform: translateY(32px) scale(.95); opacity: 0; }
@keyframes whatsapp-pulse { 50% { transform: scale(1.18); opacity: .55; } }
.app-internal-snackbar { padding: 0 !important; background: transparent !important; box-shadow: none !important; }
.app-internal-snackbar .v-snack__wrapper { box-shadow: none !important; }
.app-internal-snackbar-card { display: grid; grid-template-columns: 34px 44px minmax(0, 1fr) 22px; align-items: center; gap: 12px; width: min(440px, calc(100vw - 32px)); padding: 12px 14px; border-radius: 14px; background: #ffffff; border: 1px solid #dfe9e4; box-shadow: 0 16px 44px rgba(10, 28, 21, .18); cursor: pointer; transition: transform .18s ease, box-shadow .18s ease; }
.app-internal-snackbar-card:hover { transform: translateY(-2px); box-shadow: 0 20px 54px rgba(10, 28, 21, .22); }
.app-internal-snackbar-icon { width: 34px; height: 34px; display: flex; align-items: center; justify-content: center; border-radius: 10px; background: #075e54 !important; border: 1px solid #075e54; }
.app-internal-snackbar-avatar { background: #075e54 !important; border: 1px solid #075e54; }
.app-internal-snackbar-glyph.v-icon,
.app-internal-snackbar-icon .v-icon,
.app-internal-snackbar-avatar .v-icon { color: #ffffff !important; caret-color: #ffffff !important; opacity: 1 !important; filter: none !important; }
.app-internal-snackbar-glyph.v-icon::before,
.app-internal-snackbar-icon .v-icon::before,
.app-internal-snackbar-avatar .v-icon::before { color: #ffffff !important; opacity: 1 !important; }
.app-internal-snackbar-chevron { color: #075e54 !important; opacity: 1 !important; }
.app-internal-snackbar-copy { min-width: 0; color: #173b33; }
.app-internal-snackbar-copy strong,.app-internal-snackbar-copy small { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.app-internal-snackbar-copy strong { font-size: 14px; font-weight: 800; line-height: 1.25; }
.app-internal-snackbar-copy small { margin-top: 3px; color: #667781; }
.app-internal-snackbar-chevron { justify-self: end; }
.app-internal-snackbar-action { margin-right: 4px; color: #173b33 !important; background: #eef5f1 !important; border: 1px solid #d5e4dc; }
.app-internal-snackbar-action-dark { color: #e9edef !important; background: #0b3b2a !important; }
.app-internal-snackbar-card-dark { background: #111b21; border-color: #26343c; box-shadow: 0 16px 44px rgba(0, 0, 0, .34); }
.app-internal-snackbar-card-dark .app-internal-snackbar-icon,
.app-internal-snackbar-card-dark .app-internal-snackbar-avatar { background: #1f8f55 !important; border-color: #1f8f55; }
.app-internal-snackbar-card-dark .app-internal-snackbar-icon .v-icon,
.app-internal-snackbar-card-dark .app-internal-snackbar-avatar .v-icon,
.app-internal-snackbar-card-dark .app-internal-snackbar-icon .v-icon::before,
.app-internal-snackbar-card-dark .app-internal-snackbar-avatar .v-icon::before { color: #ffffff !important; opacity: 1 !important; }
.app-internal-snackbar-card-dark .app-internal-snackbar-chevron { color: #9be7bd !important; opacity: 1 !important; }
.app-internal-snackbar-card-dark .app-internal-snackbar-copy { color: #eef4f1; }
.app-internal-snackbar-card-dark .app-internal-snackbar-copy small { color: #9fb0a8; }
.mount-from-bottom {
  animation: mount-from-bottom .3s ease;
  user-select: none;
  -webkit-user-select: none; /* Para compatibilidade com navegadores baseados em WebKit, como o Safari */
  -moz-user-select: none; /* Para compatibilidade com navegadores baseados em Gecko, como o Firefox */
  -ms-user-select: none; /* Para compatibilidade com o Internet Explorer */
}
@keyframes mount-from-bottom {
  0% {
    /* margin-top: 40px; */
    scale: 0.99;
    opacity: 0;
  }
  40% {
    /* margin-top: -10px; */
    scale: 1.01;
  }
  100% {
    /* margin-top: 0px; */
    opacity: 1;
  }
}
@media (prefers-color-scheme: dark) {
  body {
    background: #333;
    color: white;
  }
}

@media (prefers-color-scheme: light) {
  body {
    background: #333;
    color: white;
  }
}
body,
.v-application,
.v-application .body-1,
.v-application .body-2,
.v-application .caption,
.v-application input,
.v-application textarea,
.v-application button,
.v-application .v-label,
.v-application .v-input,
.v-application .v-card__text,
.v-application .v-list-item__subtitle,
.v-application .v-tab,
.fonte,
.fonte-default {
  font-family: "Inter", "Myriad Pro Regular", Arial, sans-serif !important;
}
h1,
h2,
h3,
h4,
h5,
h6,
.v-application .text-h1,
.v-application .text-h2,
.v-application .text-h3,
.v-application .text-h4,
.v-application .text-h5,
.v-application .text-h6,
.v-application .v-card__title,
.v-application .v-toolbar__title,
.v-application .v-list-item__title,
.fonte-bold,
.font-weight-bold {
  font-family: "Poppins", "Inter", "Myriad Pro Bold", Arial, sans-serif !important;
}
.windows-style-bottom {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border: 1px solid #e0e0e0;
  border-top: none;
  background: #f2f2f2;
  padding-right: 6px;
  padding-left: 6px;
}
.bg-theme {
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
.fonteMini {
  font-size: 8pt;
}
.fonte-mini {
  font-size: 8pt;
}
.click {
  cursor: pointer;
}
.item-table {
  border-radius: 6px;
  border: 1px solid #e2e2e2;
}
.bg-table {
  background: #f2f2f2;
}
.column {
  flex-direction: column;
}
.bg_white {
  background: #fff;
}
.expande-horizontal {
  display: flex;
  width: 100%;
}
.item-list-title {
  padding: 6px;
  background: #e2e2e2;
  border-radius: 6px;
  margin-bottom: 6px;
}
.inflar {
  display: flex;
  width: 100%;
  min-height: 100vh;
}
.inflar-porcentagem {
  display: flex;
  width: 100%;
  height: 100%;
}
.centraliza {
  justify-content: center;
  align-items: center;
}
.wrap {
  flex-wrap: wrap;
}
.linha {
  flex-direction: row;
}
.fonte-default {
  font-family: "Inter", sans-serif;
}
/* @font-face {
  font-family: Sui Generis;
  src: url("/fonts/suigenerisrg.otf") format("opentype");
} */
@font-face {
  font-family: 'Myriad Pro Light';
  src: url('/fonts/myriadpro-light.otf') format('opentype');
  /* src: url('/fonts/myriadpro-light.otf') format('otf'), */
       /* url('/fonts/myriadpro-light.otf') format('otf'); */
  /* Adicione outros atributos conforme necessário, como font-weight e font-style */
}
@font-face {
font-family: 'Myriad Pro Regular';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Regular'), url('/fonts/MYRIADPRO-REGULAR.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Condensed';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Condensed'), url('/fonts/MYRIADPRO-COND.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Condensed Italic';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Condensed Italic'), url('/fonts/MYRIADPRO-CONDIT.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Light';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Light'), url('/fonts/MyriadPro-Light.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Semibold';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Semibold'), url('/fonts/MYRIADPRO-SEMIBOLD.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Semibold Italic';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Semibold Italic'), url('/fonts/MYRIADPRO-SEMIBOLDIT.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Bold Condensed';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Bold Condensed'), url('/fonts/MYRIADPRO-BOLDCOND.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Bold';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Bold'), url('/fonts/MYRIADPRO-BOLD.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Bold Italic';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Bold Italic'), url('/fonts/MYRIADPRO-BOLDIT.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Bold Condensed Italic';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Bold Condensed Italic'), url('/fonts/MYRIADPRO-BOLDCONDIT.woff') format('woff');
}
.fonte-italica {
  font-style: italic;
}
.fonte-big {
  font-size: 48px;
}
.fonte-medium {
  font-size: 36px;
}
.fonte-little {
  font-size: 24px;
}
.fonte-mini {
  font-size: 16px;
}
.fonte-micro {
  font-size: 12px;
}
/* .fonte {
  font-family: "Prompt", sans-serif;
} */

.fonte {
  font-family: "Inter", "Myriad Pro Regular", Arial, sans-serif;
}
.font-color {
  color: #363636;
}
.font-color--green {
  color: #47cf72;
}
.font-color--secondary {
  color: #1173ff;
}
.fonte-bold {
  font-family: "Poppins", "Inter", "Myriad Pro Bold Condensed", Arial, sans-serif;
}
.item-contained {
  border-radius: 6px;
  padding: 12px;
  background: #333;
}
.expande-vh-vertical {
  height: 100vh;
}

.menuAtivoHome {
  background: linear-gradient(to right, #1966e1, #2560be);
  border-radius: 1px;
  color: #f2f2f2 !important;
}
.menuAtivoHomeGold {
  background: #f12711; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #f12711,
    #f5af19
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #f12711, #f5af19);
}
.cardMesa {
  background: #1173ff; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #1173ff,
    #010a33
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #1173ff, #010c3f);
}
.bg-card-dash {
  background: linear-gradient(#1173ff, #0020ab);
}
.item {
  height: 40px;
}
.vertical-60 {
  min-height: 60vh;
}
.vitrify {
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(20px);
}
.vitrify-content {
  background: rgba(0, 0, 0, 0.1) !important;
  backdrop-filter: blur(10px) !important;
}
.vitro {
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}
.default-font-color {
  color: #1173ff;
}
.secondary-color {
  color: #e1673c;
}
.fonteMini {
  font-size: 8pt;
}
.windows-style {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border: 1px solid #e0e0e0;
  background: #f2f2f2;
  padding-right: 6px;
  padding-left: 6px;
}
.windows-style-content {
  border-bottom: 1px solid #e0e0e0;
  background: #f2f2f2;
  border-right: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.windows-style-content::-webkit-scrollbar {
  width: 8px; /* width of the entire scrollbar */
}

.windows-style-content::-webkit-scrollbar-track {
  background: rgb(226, 226, 226); /* color of the tracking area */
  border-radius: 6px;
}

.windows-style-content::-webkit-scrollbar-thumb {
  background-color: #707172; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
}
.cool-shaddow {
  box-shadow: -1px -2px 60px 2px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: -1px -2px 60px 2px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: -1px -2px 60px 2px rgba(0, 0, 0, 0.1);
}
.not-selectable {
  user-select: none;
  -webkit-user-select: none; /* Para compatibilidade com navegadores baseados em WebKit, como o Safari */
  -moz-user-select: none; /* Para compatibilidade com navegadores baseados em Gecko, como o Firefox */
  -ms-user-select: none; /* Para compatibilidade com o Internet Explorer */
}
.text-no-wrap {
  white-space: nowrap;
}
.signed-gradient {
  background-image: linear-gradient(to right, rgb(140, 85, 195), steelblue, rgb(52, 197, 182));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: black;
  user-select: none;
  -webkit-user-select: none; /* Para compatibilidade com navegadores baseados em WebKit, como o Safari */
  -moz-user-select: none; /* Para compatibilidade com navegadores baseados em Gecko, como o Firefox */
  -ms-user-select: none; /* Para compatibilidade com o Internet Explorer */
}
.dark-font {
  color: #363636
}

html,
body,
#app,
.v-application,
.v-application--wrap {
  min-height: 100vh;
}

.theme--dark.v-application,
.theme--dark .v-main,
.theme--dark .v-main__wrap,
.theme--dark .v-content,
.theme--dark .v-content__wrap,
.theme--dark .molde,
.theme--dark .vitrify-content,
.theme--dark .windows-style-content {
  background: #0b141a !important;
  color: #e9edef !important;
}

.theme--dark .windows-style,
.theme--dark .v-card:not(.dashboard-modern-card):not(.whatsapp-card):not(.sale-view-shell) {
  background-color: #111b21 !important;
  color: #e9edef !important;
  border-color: #26343c !important;
}

.theme--dark .v-data-table,
.theme--dark .v-data-table .v-data-table-header,
.theme--dark .v-data-table tbody tr,
.theme--dark .v-list,
.theme--dark .v-expansion-panels,
.theme--dark .v-expansion-panel {
  background-color: #111b21 !important;
  color: #e9edef !important;
}

.theme--dark .v-data-table td,
.theme--dark .v-data-table th,
.theme--dark .v-label,
.theme--dark .v-input input,
.theme--dark .v-input textarea,
.theme--dark .v-select__selection,
.theme--dark .v-icon {
  color: #e9edef !important;
}

.theme--dark .windows-style-content::-webkit-scrollbar,
.theme--dark .v-data-table__wrapper::-webkit-scrollbar,
.theme--dark .v-navigation-drawer__content::-webkit-scrollbar,
.theme--dark .v-main__wrap::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.theme--dark .windows-style-content::-webkit-scrollbar-track,
.theme--dark .v-data-table__wrapper::-webkit-scrollbar-track,
.theme--dark .v-navigation-drawer__content::-webkit-scrollbar-track,
.theme--dark .v-main__wrap::-webkit-scrollbar-track {
  background: #0b141a;
}

.theme--dark .windows-style-content::-webkit-scrollbar-thumb,
.theme--dark .v-data-table__wrapper::-webkit-scrollbar-thumb,
.theme--dark .v-navigation-drawer__content::-webkit-scrollbar-thumb,
.theme--dark .v-main__wrap::-webkit-scrollbar-thumb {
  background: #314249;
  border-radius: 999px;
  border: 2px solid #0b141a;
}
</style>
